import { render } from "./KsvView.vue?vue&type=template&id=556a313e&scoped=true"
import script from "./KsvView.vue?vue&type=script&lang=js"
export * from "./KsvView.vue?vue&type=script&lang=js"

import "./KsvView.vue?vue&type=style&index=0&id=556a313e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556a313e"]])

export default __exports__